import React from 'react';

export const Reset = ({
  onClick,
  className,
  color = '#2C313A',
  fillOpacity,
}) => {
  return (
    <svg
      className={`reset ${className}`}
      fill="none"
      height="20"
      viewBox="0 0 20 20"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <g id="reset">
        <path
          className="path"
          d="M17.5 9.99962C17.5002 11.9714 16.7239 13.8639 15.3391 15.2676C13.9543 16.6713 12.0724 17.4731 10.1008 17.4996H10C8.08456 17.5044 6.24085 16.7714 4.85156 15.4527C4.7919 15.3963 4.74394 15.3287 4.71042 15.2537C4.67689 15.1788 4.65846 15.0979 4.65618 15.0159C4.65389 14.9338 4.6678 14.852 4.6971 14.7753C4.7264 14.6986 4.77053 14.6284 4.82695 14.5688C4.88338 14.5091 4.95101 14.4611 5.02597 14.4276C5.10093 14.3941 5.18176 14.3757 5.26385 14.3734C5.34593 14.3711 5.42767 14.385 5.50438 14.4143C5.58109 14.4436 5.65128 14.4877 5.71094 14.5442C6.60453 15.3869 7.72663 15.9476 8.93705 16.1563C10.1475 16.365 11.3926 16.2125 12.5168 15.7177C13.641 15.2229 14.5945 14.4078 15.2582 13.3742C15.9218 12.3407 16.2663 11.1345 16.2484 9.9063C16.2305 8.67814 15.8512 7.48247 15.1577 6.46866C14.4642 5.45485 13.4874 4.66784 12.3493 4.20595C11.2112 3.74406 9.96216 3.62778 8.75832 3.87161C7.55447 4.11545 6.44916 4.7086 5.58047 5.57697C5.57409 5.58387 5.5673 5.59039 5.56016 5.5965L3.48359 7.49962H5.625C5.79076 7.49962 5.94973 7.56547 6.06694 7.68268C6.18415 7.79989 6.25 7.95886 6.25 8.12462C6.25 8.29038 6.18415 8.44936 6.06694 8.56657C5.94973 8.68378 5.79076 8.74962 5.625 8.74962H1.875C1.70924 8.74962 1.55027 8.68378 1.43306 8.56657C1.31585 8.44936 1.25 8.29038 1.25 8.12462V4.37462C1.25 4.20886 1.31585 4.04989 1.43306 3.93268C1.55027 3.81547 1.70924 3.74962 1.875 3.74962C2.04076 3.74962 2.19973 3.81547 2.31694 3.93268C2.43415 4.04989 2.5 4.20886 2.5 4.37462V6.70275L4.70703 4.68712C5.75702 3.64122 7.09333 2.92983 8.54729 2.64277C10.0012 2.35571 11.5077 2.50585 12.8764 3.07422C14.2451 3.6426 15.4147 4.60374 16.2376 5.8363C17.0605 7.06887 17.4998 8.5176 17.5 9.99962Z"
          fill={`${color}`}
          fillOpacity={fillOpacity}
        />
      </g>
    </svg>
  );
};
